var React = require('react');

function JavascriptLogoInv (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0h100v100H0V0zm26.294 83.567c2.215 4.698 6.578 8.592 14.096 8.592 8.324 0 14.03-4.43 14.03-14.164V45.91h-9.398v31.952c0 4.699-1.947 5.906-5.035 5.906-3.221 0-4.564-2.214-6.04-4.832l-7.653 4.631zm33.23-1.007c2.751 5.438 8.39 9.6 17.116 9.6 8.928 0 15.573-4.631 15.573-13.09 0-7.853-4.497-11.343-12.485-14.767l-2.35-1.007c-4.027-1.745-5.772-2.887-5.772-5.706 0-2.282 1.745-4.028 4.498-4.028 2.685 0 4.43 1.142 6.04 4.028l7.318-4.7c-3.088-5.436-7.384-7.518-13.358-7.518-8.391 0-13.761 5.37-13.761 12.419 0 7.652 4.497 11.277 11.277 14.163l2.35 1.008c4.295 1.879 6.846 3.02 6.846 6.242 0 2.685-2.483 4.632-6.377 4.632-4.631 0-7.25-2.416-9.264-5.706l-7.651 4.43z","fill":"#F7DF1E","fillRule":"evenodd"}));
}

JavascriptLogoInv.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100"};

module.exports = JavascriptLogoInv;

JavascriptLogoInv.default = JavascriptLogoInv;
